import { CreateFileQueryDto, DownloadFileQueryDto, DownloadFileResponse, GetFileInfoResponse, DeleteFileQueryDto, GetFileInfoQueryDto } from '@/@types/File';
import { vxm } from '@/store';
import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { Util } from '@/repository/repositories/utils';

export class FilesRepository {
  private readonly requestBasePath = 'v1/files';
  private readonly axios = new TheoryApiAxiosBase();
  private readonly util = new Util();
  /** ファイル登録 */
  async createFile(query: CreateFileQueryDto, params: FormData) {
    await this.axios.post(this.requestBasePath, params, {
      params: query,
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-role-param': `{'organizationId':${vxm.theoryApi.authStore.getCurrentOrganizationId},'projectId':${1}}`,
      },
    });
  }

  /** ファイルダウンロード */
  async downloadFile(fileId: number, query: DownloadFileQueryDto) {
    const endPoint = this.endPointCreator(fileId, 'downloads');
    return (await this.axios.get<DownloadFileResponse>(
      endPoint,
      { params: query },
    )).data;
  }

  /**ファイル削除 */
  async deleteFile(fileId: number, projectId: number) {
    const endPoint = this.endPointCreator(fileId);
    const query: DeleteFileQueryDto = { 'project-id': projectId };
    await this.axios.delete(endPoint, { params: query });
  }

  private endPointCreator(...paths: (string | number)[]) {
    return this.util.endPointCreator(this.requestBasePath, ...paths);
  }

  /** ファイル情報取得 */
  async getFileInfo(params: { fileId: number, projectId: number; }) {
    const endPoint = this.endPointCreator(params.fileId);
    const query: GetFileInfoQueryDto = { 'project-id': params.projectId };
    const result = await this.axios.get<GetFileInfoResponse>(endPoint, { params: query });
    return result.data;
  }
}
